
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";


/* ======================================== */
/* 2.  ENGAGEMENT FUNNEL (B2C)              */
/* ======================================== */
export const EngagementFunnel = () => {
  const data = [
    { stage: "Visited", users: 12000 },
    { stage: "Signed Up", users: 8000 },
    { stage: "Activated", users: 4500 },
    { stage: "Purchased", users: 1500 },
  ];
  const bg = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");
  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>
        Engagement Funnel
      </Heading>
      <VStack spacing={2} align="stretch">
        {data.map((d, idx) => (
          <HStack key={d.stage} spacing={4}>
            <Box w={`${(d.users / data[0].users) * 100}%`} h={6} bg="purple.500" rounded="md" />
            <Text w="90px">{d.stage}</Text>
            <Text>{d.users.toLocaleString()}</Text>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};